// extracted by mini-css-extract-plugin
export default {"footer":"RXVUuFKmzdiUEMIogUdv","extraBottomPadding":"iL7bDstuji96SGMobild","link":"TOITudVefdlDztILFpFg","topMargin":"xo8_kyVRikwtJdXHzsRw","mobile":"UOq6r097No9ZLSEYRw2b"};